import { Block } from '@aloft/toolkit-sui';
import { ReactNode } from 'react';

import { ALERT_TARGET_FIELD_TITLE } from '../../components/PropertyGrid/fields/styles.ts';
import { useRequiredFieldAlertInteraction } from './useRequiredFieldAlertInteraction.ts';

import './requiredFieldAlertHighlight.scss';

export const RequiredFieldAnchor = ({
  fieldName,
  isFieldComplete = false,
  children,
}: {
  fieldName: string;
  isFieldComplete?: boolean;
  children: ReactNode;
}) => {
  const { containerRef, isAlertHighlighted } = useRequiredFieldAlertInteraction(fieldName);
  const showAlertHighlight = isAlertHighlighted && !isFieldComplete;

  return (
    <Block
      ref={containerRef}
      data-required-field={fieldName}
      data-required-field-alert-highlight={showAlertHighlight ? '' : undefined}
      title={showAlertHighlight ? ALERT_TARGET_FIELD_TITLE : undefined}
    >
      {children}
    </Block>
  );
};
